// Copyright (c) 2022 WiseTime. All rights reserved.

import { activateI18n } from "../../locales/i18nUtil"
import { ManualTimeRow_ManualTimeCategory } from "../../generated/wisetime/user/timeline/v4/timeline_pb"
import { t } from "@lingui/macro"

activateI18n()

export type Activity = "Researching"
  | "Meeting"
  | "Phonecall"
  | "Videocall"
  | "Drafting"
  | "Corresponding"
  | "Travel"
  | "Other"
export type ActivityTypeOption = {
  name: Activity,
  value: ManualTimeRow_ManualTimeCategory,
  displayText: string,
}

export const defaultActivityOption = (): ActivityTypeOption => {
  return {
    name: "Researching",
    value: ManualTimeRow_ManualTimeCategory.RESEARCHING,
    displayText: t({ id: "option_activity_type_researching", message: "Researching" })
  }
}

// We need to generate the list lazily, otherwise the i18n might not work
export const generateActivityOptions = (): ActivityTypeOption[] => [
  defaultActivityOption(),
  {
    name: "Meeting",
    value: ManualTimeRow_ManualTimeCategory.MEETING,
    displayText: t({ id: "option_activity_type_meeting", message: "Meeting" })
  },
  {
    name: "Phonecall",
    value: ManualTimeRow_ManualTimeCategory.PHONE_CALL,
    displayText: t({ id: "option_activity_type_phonecall", message: "Phonecall" })
  },
  {
    name: "Videocall",
    value: ManualTimeRow_ManualTimeCategory.VIDEO_CALL,
    displayText: t({ id: "option_activity_type_videocall", message: "Videocall" })
  },
  {
    name: "Drafting",
    value: ManualTimeRow_ManualTimeCategory.DRAFTING,
    displayText: t({ id: "option_activity_type_drafting", message: "Drafting" })
  },
  {
    name: "Corresponding",
    value: ManualTimeRow_ManualTimeCategory.CORRESPONDING,
    displayText: t({ id: "option_activity_type_corresponding", message: "Corresponding" })
  },
  {
    name: "Travel",
    value: ManualTimeRow_ManualTimeCategory.TRAVEL,
    displayText: t({ id: "option_activity_type_travel", message: "Travel" })
  },
  {
    name: "Other",
    value: ManualTimeRow_ManualTimeCategory.OTHER,
    displayText: t({ id: "option_activity_type_other", message: "Other" })
  }
]
